import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import './module-card.scss'

const ModuleCard = ({ item }) => {

    const { homeLink } = useHomeLinkMode();

    const subtitle = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-a-module-card__subtitle">{next}</p>
        }
    };
    return (
        <div className="f-a-module-card"
            onClick={() => {
                location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/") + "modulos/" + item.redireccionBoton
            }}
        >
            <div className="f-a-module-card__content">
                <div className="f-a-module-card__background"></div>
                <div className="f-a-module-card__image-container">
                    <GatsbyImage
                        image={item.imagen[0].gatsbyImageData}
                        alt={item.imagen[0].description}
                        className="f-a-module-card__image"
                    />
                </div>
                <div className="f-a-module-card__text">
                    <h3 className="f-a-module-card__title">{item.tituloGeneral}</h3>
                    {item.descripcion.raw && documentToReactComponents(JSON.parse(item.descripcion.raw), subtitle)}
                </div>
            </div>
        </div>
    )
}

export default ModuleCard
